import { JsonPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UsuarioService } from 'src/app/account/usuario.service';
import { ComprobanteService } from 'src/app/facturacion/comprobante.service';
import { Cano } from 'src/app/shared/models/stock/Cano';
import { MessageService } from 'src/app/shell/message.service';
import { StockService } from 'src/app/stock/stock.service';
import { CuponPagoTarjeta } from '../models/facturacion/CuponPagoTarjeta';
import { Tarjeta } from '../models/facturacion/Tarjeta';


@Component({
  selector: 'app-agregar-cupon',
  templateUrl: './agregar-cupon.component.html',
  styleUrls: ['./agregar-cupon.component.css']
})
export class AgregarCuponComponent implements OnInit {

  @Input() listaCupones: CuponPagoTarjeta[];
  @Output() nuevoCupon: EventEmitter<CuponPagoTarjeta> = new EventEmitter<CuponPagoTarjeta>();

  editando: boolean = false;
  cargandoProductos: boolean = false;
  errorProductos: boolean;
  tarjetas: Tarjeta[];
  creandoCaneria: boolean = false;
  yaCargueCupon:boolean= false;

  cuponesForm = new UntypedFormGroup({
    tarjetaFormControl: new UntypedFormControl('', [Validators.required]),
    numeroTarjetaFormControl: new UntypedFormControl('', [Validators.required]),
    loteCuponFormControl: new UntypedFormControl('', [Validators.required]),
    numeroCuponFormControl: new UntypedFormControl('', [Validators.required]),
    importeFormControl: new UntypedFormControl('', [Validators.required])
  })
  constructor(public activeModal: NgbActiveModal, private comprobanteService: ComprobanteService, private usuarioService: UsuarioService, private stockService: StockService,
    private messageService: MessageService) { }

  ngOnInit() {
    this.getTarjetas();
  }

  getTarjetas() {
    // this.cargandoProductos = true;
    this.comprobanteService.getTarjetas()
      .subscribe(result => {
        this.tarjetas = result;
      })
  }

  agregarCupon() {
    this.yaCargueCupon=false;
    let c = new CuponPagoTarjeta();


    c.tarjeta = this.tarjetaFormControl.value;
    c.numeroTarjeta = this.numeroTarjetaFormControl.value;
    c.numeroLote = this.loteCuponFormControl.value;
    c.numeroCupon = this.numeroCuponFormControl.value;
    c.importe = this.importeFormControl.value;
    console.log("La lista de cupones es "+JSON.stringify(this.listaCupones))
    if (!this.estaNumeroCuponEnTarjeta(c.numeroLote, c.numeroCupon, c.numeroTarjeta))
    {
    this.nuevoCupon.emit(c);
    this.activeModal.close(true);
    }
    else
    {
     this.yaCargueCupon=true;
    }
  }

  // validaciones

  estaNumeroCuponEnTarjeta(numeroLote: number, numeroCupon: number, numeroTarjeta: number): boolean
  {

    let element:CuponPagoTarjeta;
    const encontre= this.listaCupones.some(element=> element.numeroCupon==numeroCupon && element.numeroLote==numeroLote && element.numeroTarjeta==numeroTarjeta)
    console.log("Al corroborar si el numeroCupon"+JSON.stringify(numeroCupon)+" numeroTarjeta "+JSON.stringify(numeroCupon)+" lo encontré? "+encontre);
    return encontre;
  }

  onlyNumberKey(event) {
    this.yaCargueCupon=false;
    return (event.charCode == 8 || event.charCode == 0) ? null : (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46;
  }

  get tarjetaFormControl() {
    return this.cuponesForm.get('tarjetaFormControl');
  }
  get numeroTarjetaFormControl() {
    return this.cuponesForm.get('numeroTarjetaFormControl');
  }
  get loteCuponFormControl() {
    return this.cuponesForm.get('loteCuponFormControl');
  }
  get numeroCuponFormControl() {
    return this.cuponesForm.get('numeroCuponFormControl');
  }
  get importeFormControl() {
    return this.cuponesForm.get('importeFormControl');
  }
}


